import { ReactElement } from 'react'
import Styles from './Toolbar.module.scss'

interface Props {
  children: ReactElement | ReactElement[]
}

export const ButtonGroup = ({ children }: Props) => {
  return <div className={Styles.buttonGroup}>{children}</div>
}
